<sc-sized-container [height]="600" [width]="500">
  <sc-flex fitHeight stretchContent vertical>
    <sc-dialog-title><sc-dictionary-label
    dictionaryKey="tmc-yard.control.ui.action-tablet-planned-assignment.dialog-title"></sc-dictionary-label></sc-dialog-title>
    <sc-padding leftRightOnly [formGroup]="formGroup">
      <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group" formControlName="action">
        <div>
          <mat-radio-button class="example-radio-button" value="fetch-now">
            <sc-dictionary-label
            dictionaryKey="tmc-yard.control.ui.action-tablet-planned-assignment.fetch-now"></sc-dictionary-label>
          </mat-radio-button>
        </div>
        <div>
          <mat-radio-button class="example-radio-button" value="fetch-another-transport">
            <sc-dictionary-label
            dictionaryKey="tmc-yard.control.ui.action-tablet-planned-assignment.fetch-another-transport"></sc-dictionary-label>
          </mat-radio-button>
        </div>
        <div>
          <mat-radio-button class="example-radio-button" value="disable-fetch">
            <sc-dictionary-label
            dictionaryKey="tmc-yard.control.ui.action-tablet-planned-assignment.disable-fetch"></sc-dictionary-label>
          </mat-radio-button>
        </div>
      </mat-radio-group>
    </sc-padding>
    <sc-flex-fitting-content vertical>
      @if (currentSelectedOption === 'disable-fetch') {
        <sc-padding>
          <sc-number-field
          labelDictionaryKey="tmc-yard.control.ui.action-tablet-planned-assignment.disable-fetch-minutes-count"></sc-number-field>
        </sc-padding>
      }
      @if (currentSelectedOption === 'fetch-another-transport') {
        <sc-padding fitHeight>
          <sc-scroll-pane>
            <sc-flex vertical stretchContent [gap]="16">
              @for (transport of transports; track transport) {
                <app-transport-list-entry [transport]="transport"
                (click)="selectTransportToFetch(transport)" [ngClass]="{'selected' : transport == selectedTransportToFetch}"></app-transport-list-entry>
              }
            </sc-flex>
          </sc-scroll-pane>
        </sc-padding>
      }
    </sc-flex-fitting-content>
    <sc-actionbar>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-cancel-button (click)="cancel()"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-confirm-button (click)="confirm()" primary></sc-confirm-button>
    </sc-actionbar>
  </sc-flex>
</sc-sized-container>
